import client from "./client";

const attendanceApi = {
  // Student attendance
  getStudents(params = {}) {
    // Request all students - no limit (or set high limit)
    const allParams = { ...params, limit: 10000 };
    return client.get("/attendance/students", { params: allParams }).then((r) => r.data);
  },

  markStudents(body) {
    return client.post("/attendance/students", body).then((r) => r.data);
  },

  getStudentMonthly(studentId, params = {}) {
    return client.get(`/attendance/students/${studentId}/monthly`, { params }).then((r) => r.data);
  },

  getTodayStatus(params = {}) {
    return client.get("/attendance/students/today-status", { params }).then((r) => r.data);
  },

  getWeeklyTrend(params = {}) {
    return client.get("/attendance/students/weekly-trend", { params }).then((r) => r.data);
  },

  // Teacher attendance
  getTeachers(params = {}) {
    return client.get("/attendance/teachers", { params }).then((r) => r.data);
  },

  getTeacherMonthly(teacherId, params = {}) {
    return client.get(`/attendance/teachers/${teacherId}/monthly`, { params }).then((r) => r.data);
  },

  // Proxy duties
  getProxyDuties(params = {}) {
    return client.get("/attendance/proxy-duties", { params }).then((r) => r.data);
  },

  getMyProxyDuties() {
    return client.get("/attendance/proxy-duties/my").then((r) => r.data);
  },

  computeProxyDuties(body) {
    return client.post("/attendance/proxy-duties/compute", body).then((r) => r.data);
  },

  // Absent alerts
  sendAbsentAlerts(body) {
    return client.post("/attendance/absent-alerts/send", body).then((r) => r.data);
  },

  sendAllAbsentAlerts(body) {
    return client.post("/attendance/absent-alerts/send-all", body).then((r) => r.data);
  },

  getAbsentAlertLog(params = {}) {
    return client.get("/attendance/absent-alerts/log", { params }).then((r) => r.data);
  },
};

export default attendanceApi;
